import { registerSW } from "virtual:pwa-register";
import { setAppUpdateHandler } from "./appUpdate";
import { useUIStore } from "../store/uiStore";

const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000;

/**
 * Register the service worker. A new build waits until the user accepts the
 * "New version available" prompt rather than reloading mid-edit.
 */
export function registerServiceWorker(): void {
  const updateServiceWorker = registerSW({
    onNeedRefresh() {
      useUIStore.getState().setAppUpdateReady(true);
    },
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;
      // Installed apps can stay open for days; look for deploys hourly.
      setInterval(() => {
        if (navigator.onLine) void registration.update();
      }, UPDATE_CHECK_INTERVAL_MS);
    },
  });
  setAppUpdateHandler(() => updateServiceWorker(true));
}
